import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

@Injectable()
export class DataService_MultiStationVerifyVisitor {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	VerifyVisitorInfoSelect(VisitorPassID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VerifyVisitorInfoSelect?VisitorPassID=" + VisitorPassID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
